
import PageStats from '~/components/public/page/page-stats.vue'
import PublicHeroAside from '~/components/public/hero/public-hero-aside.vue'

export default {
  components: {
    PageStats,
    PublicHeroAside,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    stats: {
      type: Array,
      default: null,
    },
  },
}
